import React, { Component } from 'react';
import { userService } from "../../../_services";
import search_icon from "../../../images/search_icon.png";
import Pagination from '../Group_no/pagination';
import WiseW9ReportRow from './WiseW9ReportRow';

class WiseW9Report extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shortname: '',
            fullName: '',
            wiseW9List: [],
            wiseW9ListTemp: [],
            filteredWiseW9List: [],
            searchText: '',
            reportUsername: '',
            report_popup: false,
            report_details: [],
            popupLoader: false,
            reportStatus: null,
            reportId: null,
            loader: false,
            pageOfItems: [],
        }
        this.handleSearchFilter = this.handleSearchFilter.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
    }

    componentDidMount() {
        let usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
        this.setState({ shortname: usernamedata.split(':')[0], fullName: usernamedata.split(':')[1] });
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.GetWiseW9ReportsAdmin(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.report_popup !== this.state.report_popup) {
            if (this.state.report_popup) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
    }

    GetWiseW9ReportsAdmin(UserId, UserName) {
        this.setState({ loader: true })
        try {
            if (userService.GetUserFinInfo) {
                userService.GetUserFinInfo(UserId, UserName)
                    .then(apidata => {
                        this.setState({ loader: false })
                        if (apidata && apidata.length > 0) {
                            this.setState({ wiseW9List: apidata, wiseW9ListTemp: apidata })
                        } else {
                            this.setState({ wiseW9List: [], wiseW9ListTemp: [] })
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        this.setState({ loader: false, wiseW9List: [], wiseW9ListTemp: [] })
                    });
            } else {
                // Mock data for demonstration
                this.setState({
                    loader: false,
                    wiseW9List: [],
                    wiseW9ListTemp: []
                })
            }
        }
        catch (err) {
            console.log(err)
            this.setState({ loader: false })
        }
    }

    handleSearchFilter = (val, e) => {
        try {
            const { wiseW9ListTemp } = this.state
            let serachText = '';
            if (e == undefined) {
                serachText = val;
            }
            else {
                serachText = e.target.value;
            }

            let duplicateWiseW9List = wiseW9ListTemp.filter(function (e1) {
                return (e1.email && e1.email.toLowerCase().indexOf(serachText.toLowerCase()) !== -1) ||
                    (e1.fullName && e1.fullName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1) ||
                    (e1.userName && e1.userName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1) ||
                    (e1.phone && e1.phone.toLowerCase().indexOf(serachText.toLowerCase()) !== -1) ||
                    (e1.wiseStatus && e1.wiseStatus.toLowerCase().indexOf(serachText.toLowerCase()) !== -1) ||
                    (e1.w9Status && e1.w9Status.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
            });

            if (duplicateWiseW9List.length > 0) {
                this.setState({ wiseW9List: duplicateWiseW9List });
            } else {
                if (serachText.length === 0) {
                    this.setState({ wiseW9List: wiseW9ListTemp });
                } else {
                    this.setState({ wiseW9List: [] });
                }
            }
        }
        catch (err) { }
    }

    toggle_report_details_popup = (e, reportId, reportUsername, reportStatus) => {
        try {
            e.stopPropagation();
            this.setState({ report_popup: !this.state.report_popup, popupLoader: true, reportId: reportId, reportUsername: reportUsername })
            if (reportId && reportId !== '-') {
                // TODO: Replace with actual API call for Wise & W-9 report details
                if (userService.FetchWiseW9ReportDetailsAdmin) {
                    userService.FetchWiseW9ReportDetailsAdmin(reportId)
                        .then(apidata => {
                            this.setState({ report_details: apidata, popupLoader: false })
                        })
                        .catch(err => {
                            this.setState({ report_details: [], popupLoader: false })
                        });
                } else {
                    this.setState({ report_details: [], popupLoader: false })
                }
            } else {
                if (reportId === '-') {
                    this.setState({ report_details: [], popupLoader: false, report_popup: true, reportStatus: JSON.parse(reportStatus) })
                } else {
                    this.setState({ report_details: [], popupLoader: false })
                }
            }
        }
        catch (err) { }
    }

    onChangePage(pageOfItems) {
        try {
            this.setState({ pageOfItems: pageOfItems });
        }
        catch (err) { }
    }

    render() {
        let { loader, pageOfItems, wiseW9List } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;

        return (
            <div>
                <span className="back-button" onClick={this.props.hideWiseW9Section}>Back</span>
                <div className="page-heading-row nlsorder_header monthly_comm">
                    <h2>Wise & W-9 Report</h2>
                    {loader && <div className="page-loader"></div>}
                </div>
                <div className="header_bard_button userpage_header_bard nlsreportpage_header">
                    <div className="searchbar">
                        <img src={search_icon} alt="" />
                        <input type="text" disabled={disabled} id="SearcInput" className="form-control searchTable searchtextarea" autoComplete="off" name="searchtext" placeholder="Search" onKeyUp={this.handleSearchFilter.bind(this, '')} />
                    </div>
                </div>
                <div className="tab-content">
                    <div className="new-report">
                        <div className="tabular_box nls_report_table">
                            <div className="table_header w9adminreportheader user_page user_data main">
                                <div>User Name</div>
                                <div>Full Name</div>
                                <div>Email</div>
                                <div>Phone</div>
                                <div>User Type</div>
                                <div>Wise Details</div>
                                <div>W-9 Details</div>
                            </div>
                            <div className="table_body">
                                {loader ? <div className="norecords">Records are loading..</div> :
                                    <>
                                        {pageOfItems && pageOfItems.length ? pageOfItems.map((reportrow, index) =>
                                            <WiseW9ReportRow
                                                index={index}
                                                key={index}
                                                {...reportrow}
                                                toggle_report_details_popup={(e) => this.toggle_report_details_popup(e, reportrow.reportId, reportrow.userName, reportrow.status)}
                                            />
                                        ) : <div className="norecords">No record found</div>}
                                    </>}
                            </div>
                            <Pagination items={wiseW9List} onChangePage={this.onChangePage} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default WiseW9Report;